module.exports = __webpack_public_path__ + "img/msk.65d14c5d.jpg";